import React, { useState, useEffect, useRef, useContext } from "react";
import { translateCol } from "../../../../custom/columnI18n";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import useVisinaTabele from "../../../../custom/visinaTabele";

const KlijentiPregled = (props) => {
  const { t } = useTranslation();
    const {changeView} = props

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

  // Path normalization and document location helper
  const getDocumentLocation = (path) => {
    if (!path) return null;
    
    // Normalize Windows path to URL format
    const normalizedPath = path.replace(/\\/g, '/');
    
    // Remove full C:/Dokumenta/ from path
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const getDocumentName = (pregled) => {
    switch (pregled) {
      case 1: return `returnAllDataClients`;
      case 2: return `returnAllDataClientsNBS`;
      case 3: return `returnAllDataClientsAPR`;
      default: return `returnAllDataClients`;
    }
};

const getConfigColumns = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 263
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

     if(data.length > 0) {
                    return { empty: false, data: data };
                } else {
                    return { empty: true, data: [] };
                }


};


  useEffect(() => {

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + `/clients/${getDocumentName(changeView)}`, requestOptions)
      .then(handleErrors)
      .then(async (data) => {
        setTableData(data);
        
          // Extract all available columns from the first data row
            if (data && data.length > 0) {
        const columns = Object.keys(data[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));
  
          
          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);
          
          if(changeView == 1) {
             const columnsDB = await getConfigColumns();

              if (!columnsDB.empty && columnsDB.data.length > 0) {
                const arr = JSON.parse(columnsDB.data[0].parametri);
                setSelectedColumns(arr);
              } else {
                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
              }
          } else {
            setSelectedColumns(columns.slice(0, 5).map(col => col.value));
          }
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token, company.companyId, changeView]);

 const previewBodyTemplate = (rowData, field) => {
  const filePathsString = rowData[field];
  if (!filePathsString) return '-';

  const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {filePaths.map((path, idx) => {
        const documentUrl = getDocumentLocation(path);
        if (!documentUrl) return null;

        // Izdvoji ime fajla bez ekstenzije
        const fileNameWithExt = path.split('/').pop(); // npr. TOI-Psihologija-2016-testkljuc_20250726222909703.pdf
        const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');

        return (
          <Button
            key={idx}
            label={fileName}
            icon="pi pi-eye"
            className="p-button-text p-button-sm"
            onClick={() => window.open(documentUrl, '_blank')}
            tooltip="Pregledaj dokument"
            tooltipOptions={{ position: 'top' }}
          />
        );
      })}
    </div>
  );
};

  //PROMENITI KAD SE SREDI UNOS
  const isFileColumn = (field) => {
    return field.startsWith('Fajl') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Klijenti');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns.map(c => translateCol(t, c));
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Klijenti - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
          <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
          </div>
          <input
               type="search"
               onInput={(e) => setGlobalFilter(e.target.value)}
               placeholder={t('nova.phPretraga')}
               className="p-inputtext p-component"
               />
      </div>
      );

       const handleSaveConfig = () => {
               confirmDialog({
                          message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                          acceptLabel: "Da",
                          rejectLabel: "Ne",
                          icon: "pi pi-info-circle",
                          acceptClassName: "p-button-danger",
                          accept: acceptInsertConfig,
                          reject: rejectInsertConfig,
                          });
        }
      
        const acceptInsertConfig  = () => {
         if(selectedColumns.length > 0) {
            let requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + auth.token,
            },
            body: JSON.stringify({
              id_config: 263,
              parametri: selectedColumns
            }),
          };
          
          fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
            .then(handleErrors)
            .then((data) => {
      
                  if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                      toast.current.show({
                          severity: "warn",
                          summary: t('admin.m_upozorenje_2'),
                          detail: data.message,
                          life: 3000,
                          });
                      return
                      }  
        
                  toast.current.show({
                      severity: "success",
                      summary: t('admin.m_uspesna_izmena_konfiguracije_pregleda_za'),
                      life: 3000,
                  });
      
            })
            .catch((error) => {
              error.json().then((errorMessage) => {
                toast.current.show({
                  severity: "error",
                  summary: "Error",
                  detail: errorMessage.message,
                  life: 3000,
                });
                console.log(errorMessage);
              });
            }); 
          } else {
              toast.current.show({
                          severity: "warn",
                          summary: t('admin.m_upozorenje_2'),
                          detail: t('admin.m_morate_imati_barem_1_izabranu_stavku'),
                          life: 3000,
                          });
          }
        }
        const rejectInsertConfig = () => {
          console.log('Config insert rejected!')
        }

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
                <div style={{ width: "20%" }}>
                  {allColumns.length > 0 && ( changeView && changeView == 1 ?   <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
                      value={selectedColumns}
                      options={allColumns}
                      onChange={(e) => {
          const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
          setSelectedColumns(sorted);
        }}
                      optionLabel="label"
                      display="chip"
                      placeholder={t('nova.odaberiteKolone')}
                      style={{ width: '100%' }}
                      showSelectAll={true}
                      filter
                      filterPlaceholder="Pretraži kolone"
                      maxSelectedLabels={3}
                      selectedItemsLabel="{0} kolona odabrano"
                    /> <button onClick={handleSaveConfig} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div> : <MultiSelect
                      value={selectedColumns}
                      options={allColumns}
                      onChange={(e) => {
          const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
          setSelectedColumns(sorted);
        }}
                      optionLabel="label"
                      display="chip"
                      placeholder={t('nova.odaberiteKolone')}
                      style={{ width: '100%' }}
                      showSelectAll={true}
                      filter
                      filterPlaceholder="Pretraži kolone"
                      maxSelectedLabels={3}
                      selectedItemsLabel="{0} kolona odabrano"
                    />
                  )}
                </div>
      </div>
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
      >
         {selectedColumns.map((colKey) => {
               const colMeta = allColumns.find(col => col.value === colKey);
               return (
                 <Column
                   key={colKey}
                   field={colKey}
                   header={translateCol(t, colMeta?.label || colKey)}
                   sortable
                   body={(rowData) => {
                     if (isFileColumn(colKey)) {
                       return previewBodyTemplate(rowData, colKey);
                     }
                     return rowData[colKey] || '-';
                   }}
                   style={{ minWidth: '150px' }}
                 />
               );
             })}
      </DataTable>
      </div>
    </div>
  );
};

export default KlijentiPregled;